import { render, staticRenderFns } from "./SalePurchaseOrderEdit.vue?vue&type=template&id=27c85b68&"
import script from "./SalePurchaseOrderEdit.vue?vue&type=script&lang=js&"
export * from "./SalePurchaseOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports